import { AxiosResponse } from 'axios'
import { api } from './api'

export interface TrainingSearchRequest {
	vehicleId: number
	map: string
}

export default class TrainingService {

	static async startSearch(vehicleId: number, map: string): Promise<AxiosResponse<void>> {
		return api.post<void>('/trainings/search/start', { vehicleId, map })
	}

	static async stopSearch(): Promise<AxiosResponse<void>> {
		return api.post<void>('/trainings/search/stop')
	}

	static async leave(): Promise<AxiosResponse<void>> {
		return api.post<void>('/trainings/leave')
	}
}